// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2lmPN","emails":"CreateEditClinics_emails__1zdM2","emailTagLabel":"CreateEditClinics_emailTagLabel__2zX3c"};